const FORBIDDEN_KEYWORDS =
  /\b(insert|update|delete|merge|drop|alter|create|truncate|exec|execute|grant|revoke|backup|restore|into|waitfor|openrowset|openquery|opendatasource)\b/i;

export const SELECT_QUERY_ERROR =
  "Sono ammesse solo query di tipo SELECT, senza istruzioni di modifica.";

export function isSelectQuery(sql) {
  if (!sql || !sql.trim()) {
    return false;
  }

  const normalized = sql
    .replace(/\/\*[\s\S]*?\*\//g, " ")
    .replace(/--.*$/gm, " ")
    .trim()
    .replace(/;+\s*$/g, "")
    .trim();

  if (!normalized || normalized.includes(";")) {
    return false;
  }

  const firstToken = normalized.split(/\s+/)[0];
  if (!firstToken || !/^(select|with)$/i.test(firstToken)) {
    return false;
  }

  if (!/\bselect\b/i.test(normalized)) {
    return false;
  }

  if (FORBIDDEN_KEYWORDS.test(normalized) || /\b(sp_|xp_)/i.test(normalized)) {
    return false;
  }

  return true;
}
